<template>
    <v-dialog
        v-model="dialog"
        :max-width="options.width"
        :style="{ zIndex: options.zIndex }"
        @keydown.esc="cancel"
        class="tw-text-center"
    >
        <h5 class="tw-capitalize tw-text-secondary tw-text-center tw-px-3 tw-py-3">
            {{ title }}
        </h5>
        <div
            v-show="!!message"
            class="tw-px-3 tw-text-center"
            v-html="message"
        >
        </div>
        <div class="tw-flex tw-flex-row tw-justify-end tw-px-4 tw-mt-5 tw-gap-3">
            <v-text-field
                v-show="options.showInput"
                :label="options.inputName"
                v-model="input"
            />
            <v-spacer></v-spacer>
            <v-btn
                v-if="!options.noconfirm"
                color="grey"
                text
                class="body-2 font-weight-bold"
                @click.native="cancel"
            >{{ $page.language.buttons.BUTTON_CANCEL }}</v-btn
            >
            <v-btn
                color="primary"
                class="body-2 font-weight-bold"
                outlined
                @click.native="agree"
                :disabled="options.showInput && !input"
            >{{ $page.language.buttons.BUTTON_OK }}</v-btn
            >
        </div>


    </v-dialog>
</template>

<script>
export default {
    name: "ConfirmDialog",
    data() {
        return {
            dialog: false,
            resolve: null,
            reject: null,
            message: null,
            title: null,
            options: this.defaultOptions(),
            input: null,
            confirmed_input: null,
        }
    },
    methods:{
        open(title, message, options) {
            this.dialog = true;
            this.title = title;
            this.message = message;
            this.options = Object.assign(this.options, options);
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        agree() {
            this.resolve(true)
            this.dialog = false
            this.confirmed_input = this.input
            this.input = null
            this.options = this.defaultOptions()
        },
        cancel() {
            this.resolve(false)
            this.dialog = false
            this.input = null
            this.options = this.defaultOptions()
        },
        defaultOptions() {
            return {
                color: "grey lighten-3",
                width: 400,
                zIndex: 200,
                noconfirm: false,
                showInput: false,
                inputName: 'Input',
            }
        },
    }
}
</script>
